import { useEffect, useState } from "react"
import {
  createBridge,
  createAppSession,
  type AppBridge,
  type AppClient,
  type AppContext,
  type AppSession,
} from "@koortex/apps-sdk"

const CAPABILITIES = [
  "toast",
  "navigate.crm",
  "context.read",
  "files.upload",
  "request.action",
  "refresh.badge",
] as const

export interface AppShell {
  context: AppContext
  client: AppClient
  bridge: AppBridge
  /**
   * JWT mais recente — para fetches binários autenticados (o client SDK só faz
   * JSON/text). Getter e não string: o host renova o token (30 min) sem recarregar.
   */
  getToken: () => string
}

export type ShellState =
  | { kind: "loading" }
  | { kind: "ready"; shell: AppShell }
  | { kind: "no-token" }
  | { kind: "bad-token"; error: string }

export function useAppShell(): ShellState {
  const [state, setState] = useState<ShellState>({ kind: "loading" })

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const token = params.get("token")
    if (!token) {
      setState({ kind: "no-token" })
      return
    }
    // Sessão: recebe tokens novos do host sem recarregar a iframe (o reload
    // reabria-a com o mesmo token expirado do URL) e repete o pedido após 401.
    let session: AppSession
    try {
      session = createAppSession(token)
    } catch (err) {
      setState({ kind: "bad-token", error: err instanceof Error ? err.message : String(err) })
      return
    }
    const bridge = createBridge({ allowedCapabilities: [...CAPABILITIES] })
    setState({
      kind: "ready",
      shell: {
        context: session.context,
        client: session.client,
        bridge,
        getToken: session.getToken,
      },
    })
    return () => session.dispose()
  }, [])

  return state
}
